import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "questionsContainer",
    "questionTemplate",
    "questionItem",
    "questionNumber",
    "optionsField",
  ];

  connect() {
    this.questionIndex = this.questionItemTargets.length;
    this.updateQuestionNumbers();
  }

  addQuestion(event) {
    event.preventDefault();

    const template = this.questionTemplateTarget.content.cloneNode(true);
    const questionItem = template.querySelector(
      '[data-survey-builder-target="questionItem"]',
    );

    // Replace INDEX placeholder with actual index
    const htmlString = questionItem.innerHTML.replace(
      /INDEX/g,
      this.questionIndex,
    );
    questionItem.innerHTML = htmlString;

    // Update position input
    const positionInput = questionItem.querySelector(".position-input");
    if (positionInput) {
      positionInput.value = this.questionIndex;
    }

    this.questionsContainerTarget.appendChild(questionItem);
    this.questionIndex++;
    this.updateQuestionNumbers();
  }

  removeQuestion(event) {
    event.preventDefault();

    const questionItem = event.target.closest(
      '[data-survey-builder-target="questionItem"]',
    );
    if (questionItem) {
      // If this is an existing question, mark it for destruction
      const idInput = questionItem.querySelector('input[name*="[id]"]');
      if (idInput) {
        const destroyInput = document.createElement("input");
        destroyInput.type = "hidden";
        destroyInput.name = idInput.name.replace("[id]", "[_destroy]");
        destroyInput.value = "1";
        questionItem.appendChild(destroyInput);
        questionItem.style.display = "none";
      } else {
        // New question, just remove it
        questionItem.remove();
      }

      this.updateQuestionNumbers();
    }
  }

  toggleOptions(event) {
    const select = event.target;
    const questionItem = select.closest(
      '[data-survey-builder-target="questionItem"]',
    );
    const optionsField = questionItem.querySelector(
      '[data-survey-builder-target="optionsField"]',
    );
    const optionsTextarea = optionsField.querySelector("textarea");
    const optionsLabel = optionsField.querySelector("label");

    const questionType = select.value;
    const needsOptions = ["multiple_choice", "checkbox", "rating"].includes(
      questionType,
    );

    if (needsOptions) {
      optionsField.classList.remove("hidden");

      // Update placeholder and label based on question type
      if (questionType === "rating") {
        optionsTextarea.placeholder = "Enter max rating (e.g., 5 or 10)";
        optionsLabel.querySelector(".text-xs").textContent =
          "(enter max rating value)";
        optionsTextarea.rows = 1;
      } else {
        optionsTextarea.placeholder = "Enter one option per line";
        optionsLabel.querySelector(".text-xs").textContent =
          "(one per line for choices)";
        optionsTextarea.rows = 4;
      }
    } else {
      optionsField.classList.add("hidden");
      optionsTextarea.value = "";
    }
  }

  updateQuestionNumbers() {
    const visibleQuestions = Array.from(this.questionItemTargets).filter(
      (item) => {
        return item.style.display !== "none";
      },
    );

    visibleQuestions.forEach((item, index) => {
      const numberSpan = item.querySelector(
        '[data-survey-builder-target="questionNumber"]',
      );
      if (numberSpan) {
        numberSpan.textContent = index + 1;
      }

      // Update position input
      const positionInput = item.querySelector(".position-input");
      if (positionInput) {
        positionInput.value = index;
      }
    });
  }
}
